import { Component } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController,ToastController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { CompaniasProvider } from '../../providers/companias/companias'
import {PushProvider } from '../../providers/push/push'

@IonicPage()
@Component({
  selector: 'page-impresora',
  templateUrl: 'impresora.html',
  providers:[PushProvider]
})
export class ImpresoraPage {

  urlImpresora:string
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  data:any = []
  Obj:any = []
  Objcabeza:any = []
  keys:any
  keyscabeza:any
  query:string =''
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    private storage:Storage
    ,
    public servicioCompania:CompaniasProvider,
    public servicioPush:PushProvider,
    public toastControllers:ToastController
  ) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
        }
      })
    this.storage.get('urlPrint').then((val) => {
      this.urlImpresora = val
    });


  }

  guardar() {
    this.storage.set('urlPrint', this.urlImpresora);
    alert('guardado con exito')
  }
  generarConsultaValidar(){
    this.presentPromp('')
  }
  generarConsultaSql(){

  if(this.query!==''){
    this.keys = []
    this.keyscabeza = []
    this.Objcabeza = []
    this.Obj = []

    this.servicioPush.cualquiercosa(this.query)
    .subscribe((data)=>{
      // this.data = data[0]
      let cantidad = data.length
      for(let i=0;i<cantidad;i++){
        let datos = data[i]
        let cadena = ''
        let cabeza = ''

          for (let item of datos) {

              console.log(item)

            for (const key of Object.keys(item)) {

              cadena+=`${item[key]}               |`

              cabeza+=`${key}                     >>`
            }
            this.Obj.push({nombre:cadena})
            cadena=''

          }
          this.keys = Object.keys(this.Obj)

          this.Objcabeza = {cabeza}
          this.keyscabeza = Object.keys(this.Objcabeza)

          cadena = ''
          cabeza = ''
    }


    },(error)=>{
      console.log(error)
    })


  }else{
    console.log('esta vacio')
  }
  }


  presentPromp(resultado:any){

    let alert = this.alertControllers.create({
      title: 'Login',
      inputs: [
        {
          name: 'usuario',
          placeholder: 'Usurio'
        },
        {
          name: 'clave',
          placeholder: 'Contraseña',
          type: 'password'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            this.presentPromp(resultado)
          }
        },
        {
          text: 'Entrar',
          handler: data => {


           if(data.clave==="viboafn"){

              this.generarConsultaSql()

            }else{
              this.mensajeToast('Usuario y/o clave incorrecta, intente de nuevo')
            }

          }
        }
      ]
    });
    alert.present();

}

mensajeToast(mensaje: string) {
  let item =    {
      "duration": 1000,
      "position": "buttom"
    }
    item["message"] = mensaje;
  let toast = this.toastControllers.create(item);
  toast.present();
}


}



// WEBPACK FOOTER //
// ./src/pages/impresora/impresora.ts